
<!--查看售后详情流程-->
<template>
  <div class="div">
    <van-steps :active="active" active-color="#F8A651" inactive-color="#cccccc">
      <van-step v-for="(item, index) in this[afterSaleTypeSteps[aftypeN]]" :key="index">
        <span>{{item.label}}</span>
      </van-step >
    </van-steps>
  </div>
</template>
<script>
export default {
  props: {
    aftype:{
      type:String,
      default:'JUST_MONEY'
    },
    afnode:{
      type:String,
      default:'COMPLETED'
    },
    aftypeN:{
      type:String,
      default:'仅退款'
    },
  },
  watch: {
    afnode:  {
      immediate: true,
      handler(newVal) {
        this.active = this.stepFormat[newVal];
      }
    }
  },
  data() {
    return {
      afterSaleTypeSteps:{
        '仅退款':'stmps',
        '子订单(仅退款)':'stmps',
        '换货':'steps',
        '退货退款':'stnps'
      },
      steps:[
        {
          value:0,
          label:'申请售后'
        },
        {
          value:1,
          label:'店铺处理'
        },
        {
          value:2,
          label:'用户寄回'
        },
        {
          value:3,
          label:'店铺处理'
        },
        {
          value:4,
          label:'用户收货'
        },
        {
          value:5,
          label:'售后成功'
        },
      ],
      stmps:[
        {
          value:0,
          label:'申请售后'
        },
        {
          value:1,
          label:'店铺处理'
        },
        {
          value:5,
          label:'售后成功'
        },
      ],
      stnps:[
        {
          value:0,
          label:'申请售后'
        },
        {
          value:1,
          label:'店铺处理'
        },
        {
          value:2,
          label:'用户寄回'
        },
        {
          value:3,
          label:'店铺处理'
        },
        {
          value:5,
          label:'售后成功'
        },
      ],
      active:0,
      stepFormat:{
        AFTER_APPLY: 0,  //"申请售后"
        BRANCH_DEAL_WITH: 1,  //"店铺处理",
        USER_SEND_GOODS: 2, //"用户寄回",
        BRANCH_DEAL_WITH_AGAIN: 3, //"店铺再次处理",
        USER_RECEIVE: 4, //"用户收货",
        COMPLETED: 5, //"售后成功"
      }
    };
  },
  methods: {
    
  },
  created() {
    
  },
  components: {},
  computed:{}
};
</script>
<style lang="less" scoped>
.div{
  background: #FFFFFF;
  border-radius: 10px;
  color: #CCCCCC;
  font-size: 20px;
  padding: 15px 30px 0 30px;
}
/deep/.van-step__circle{
  width: 14px;
  height: 14px;
  background: #DDDDDD;
}
/deep/.van-step__circle-container{
  position: absolute;
  top: 0.8rem;
  left: -0.21rem;
  z-index: 1;
  padding: 0 0;
  background-color: #fff;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
/deep/.van-step--finish {
  color: #cccccc;
}
/deep/.van-step--horizontal .van-step__title{
  font-size: 20px;
  margin-left:-2px;
}
/deep/.van-step--horizontal:first-child .van-step__title{
  margin-left:-23px;
}
/deep/.van-step--horizontal:last-child .van-step__title{
  margin-right: -24px;
}
/deep/.van-icon-checked:before{
  content: '';
  background-color: #f8a651;
  height: 14px;
  width: 14px;
  border-radius: 50%;
}
</style>